import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import imageIconPortrait from './icon/orientation_portrait.svg';
import imageIconLandscape from './icon/orientation_landscape.svg';
import translations from './lang/translations';
export default class ChangeOrientation extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const { t } = editor.locale;
        
        editor.ui.componentFactory.add( 'changeOrientation', locale => {
            const view = new ButtonView( locale );
            let orientationValue = document.querySelector('input[name="orientation"]');
            let imageIcon = imageIconPortrait;
            let enabled = true;
            if(!orientationValue){
                enabled = false;
            }
            if(orientationValue && orientationValue.value == 'landscape'){
                imageIcon = imageIconLandscape;
            }
            view.set( {
                label: t('Change orientation'),
                icon: imageIcon,
                tooltip: true,
                isEnabled: enabled,
            } );

            // Callback executed once the image is clicked.
            view.on( 'execute', () => {
                let formElement = document.querySelector('#certificate-form');
                let ckEditorElement = document.querySelectorAll('.ck-editor__editable_inline, .ck-editor__main');

                if(orientationValue && orientationValue.value == 'portrait'){
                    orientationValue.value = 'landscape';
                    view.icon = imageIconLandscape;
                    formElement.classList.remove('portrait-form');
                    formElement.classList.add('landscape-form');
                    [...ckEditorElement].forEach(e => {
                        e.style.setProperty('min-height', '794px', 'important');
                        e.style.setProperty('height', '794px', 'important');
                    });
                    sessionStorage.setItem('certificate_orientation','landscape');
                }else if(orientationValue && orientationValue.value == 'landscape'){
                    orientationValue.value = 'portrait';
                    view.icon = imageIconPortrait;
                    formElement.classList.remove('landscape-form');
                    formElement.classList.add('portrait-form');
                    [...ckEditorElement].forEach(e => {
                        e.style.setProperty('min-height', '1123px', 'important');
                        e.style.setProperty('height', '1123px', 'important');
                    });
                    sessionStorage.setItem('certificate_orientation','portrait');
                }    
            });

            return view;
        });
    }
}